<template>
  <el-dialog
    width="500px"
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    class="default-dialog"
  >
    <div class="title">员工批量设置</div>
    <el-form :model="form" ref="form" label-width="120px" >
      <el-form-item label="部门：">
        <el-select v-model="deptId" placeholder="请选择" size="small">
          <el-option
            v-for="item in departmentList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计提工资科目：">
        <el-select v-model="subujectId" placeholder="请选择" size="small" filterable >
          <el-option
            v-for="item in subujectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否在职：">
         <el-select v-model="status" placeholder="请选择" size="small">
          <el-option
            v-for="item in userStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="status" >
        <template #label>
          <span style="margin-right:2px;color:red;" >*</span>{{status==1?'入职时间：':'离职时间：'}}
        </template>
        <el-date-picker
          v-model="date"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
        <span style="color:#FF6010;">工资{{status==1?'始':'停'}}发日默认为{{status==1?'入职':'离职'}}日期</span>
      </el-form-item>
    </el-form>
    <div class="footer acc_flex">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" class="submit" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {updateUsersProjectAndDept} from '@/api/index.js'
export default {
  props: {
    selectList:{
      type:Array,
      default:()=>[]
    },
    departmentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form:{},
      date:"",
      userStatus:[
        {
          id:1,
          name:'在职'
        },
        {
          id:2,
          name:'离职'
        }
      ],
      status:'',
      staffList:[],
      subujectList:[],
      subujectId: "",
      deptId: "",
      visible: false,
    };
  },
  methods: {
    //获取科目
    findObject() {
      this.$http.post("subject/getSujectByContent", {}).then((res) => {
        if (res && res.data.code == "1") {
            this.subujectList = res.data.data
        }
      });
    },

    openTask(list) {
      this.status = ''
      this.subujectId = ''
      this.deptId = ''
      this.date = ''
      this.status = ''
      this.staffList = list
      this.visible = true;
      this.findObject()
    },
    submit() {

      if(this.status&&!this.date){
        this.$message.error(`请选择${this.status==1?'入职':'离职'}时间`)
        return
      }
      let params = {
        deptId:this.deptId,
        subujectId:this.subujectId,
        employeeIds:this.selectList.join(','),
        status:this.status,
        date:this.date
      }
      let deptName = this.departmentList.find(e=>e.id==params.deptId)
      let subjectName = this.subujectList.find(e=>e.id==params.subujectId)
      params.deptName = deptName?deptName.name:''
      params.subjectName = subjectName?subjectName.name:''
      updateUsersProjectAndDept(params).then(res=>{
        if(res.data.code==1){
          this.$message.success(res.data.msg)
          this.visible = false
          this.$emit('refsh')
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 30px 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/SettingStaff.vue